import { useSyncExternalStore } from 'react';

// On window: the app and project-management bundles each bundle their own copy of this module.
const EVENT = 'wb:intercom-messenger';
const KEY = '__intercomMessengerOpen';
type OpenState = Window & { [KEY]?: boolean };

const isOpen = (): boolean => !!(window as OpenState)[KEY];

export const setMessengerOpen = (open: boolean): void => {
  if (isOpen() === open) return;
  (window as OpenState)[KEY] = open;
  window.dispatchEvent(new Event(EVENT));
};

const subscribe = (onChange: () => void) => {
  window.addEventListener(EVENT, onChange);
  return () => window.removeEventListener(EVENT, onChange);
};

/** True while the Intercom messenger iframe is open and may hold keyboard focus. */
export const useIntercomMessengerOpen = (): boolean => useSyncExternalStore(subscribe, isOpen);
